<av-content-container>
    <div class="col-6 mb-4">
        <av-card cardTitle="app.device.hardware.sections.bios.title" icon="memory" [fields]="biosFields()" />
    </div>

    <div class="col-6 mb-4">
        <av-card cardTitle="app.device.hardware.sections.processor.title" icon="developer_board"
            [fields]="processorFields()" />
    </div>

    <div class="col-12 d-flex align-items-stretch">
        <av-table-card [titleKey]="'app.device.hardware.storage.title'" icon="storage" [columns]="storageColumns"
            [rows]="storageRows()" [countLabelKey]="'app.device.hardware.storage.disks_found_suffix'"
            [emptyTextKey]="'app.device.hardware.storage.empty'" />
    </div>
</av-content-container>